



// // const API_BASE = "https://assocham.org/api";

// // const SLUG_OVERRIDES = {
// //   // "andhra-pradesh": "andhra-pradesh-state-development-council",
// //   // "jammu-kashmir": "jk-state-development-council",
// // };

// // export async function getRegionBySlug(slug) {
// //   if (!slug) return null;
// //   const dbSlug = SLUG_OVERRIDES[slug] || slug;

// //   try {
// //     const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
// //     const json = await res.json();

// //     if (!json.success) return null;
// //     return json.data;
// //   } catch (err) {
// //     console.error("getRegionBySlug error:", err);
// //     return null;
// //   }
// // }

// // export async function getCouncilLeadership(slug) {
// //   try {
// //     // ✅ Use absolute URL with API_BASE
// //     const res = await fetch(`${API_BASE}/getCouncilLeadership-state.php?slug=${encodeURIComponent(slug)}`);
// //     const json = await res.json();
// //     if (json.success) {
// //       return json.data;
// //     }
// //     return [];
// //   } catch (error) {
// //     console.error('Failed to fetch council leadership:', error);
// //     return [];
// //   }
// // }


// // export async function fetchRegionEvents(slug) {
// //   if (!slug) return [];
// //   try {
// //     // Make sure slug is a clean string without quotes
// //     const cleanSlug = slug.replace(/^"|"$/g, ''); // Remove surrounding quotes if any
// //     const res = await fetch(`${API_BASE}/get_region_events.php?slug=${encodeURIComponent(cleanSlug)}`);
// //     const json = await res.json();
// //     if (!json.success) return [];
// //     return json.data || [];
// //   } catch (err) {
// //     console.error("fetchRegionEvents error:", err);
// //     return [];
// //   }
// // }





// // new new code 






// // regionApi.js

// const API_BASE = "https://assocham.org/api";

// // 🔑 Map frontend slugs to database slugs
// const SLUG_OVERRIDES = {
//   "tamil-nadu": "tamil-nadu-state-development-council",
//   // Add other states if their frontend slug differs from the DB slug
//   // "andhra-pradesh": "andhra-pradesh-state-development-council",
//   // "karnataka": "karnataka-state-development-council",
// };

// export async function getRegionBySlug(slug) {
//   if (!slug) return null;
//   const dbSlug = SLUG_OVERRIDES[slug] || slug;
//   console.log('[getRegionBySlug] frontend slug:', slug, '→ DB slug:', dbSlug);

//   try {
//     const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) return null;
//     return json.data;
//   } catch (err) {
//     console.error("getRegionBySlug error:", err);
//     return null;
//   }
// }

// export async function getCouncilLeadership(slug) {
//   if (!slug) return [];
//   const dbSlug = SLUG_OVERRIDES[slug] || slug;
//   try {
//     const res = await fetch(`${API_BASE}/getCouncilLeadership-state.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (json.success) {
//       return json.data;
//     }
//     return [];
//   } catch (error) {
//     console.error('Failed to fetch council leadership:', error);
//     return [];
//   }
// }

// export async function fetchRegionEvents(slug) {
//   if (!slug) return [];
//   const dbSlug = SLUG_OVERRIDES[slug] || slug;
//   console.log('[fetchRegionEvents] frontend slug:', slug, '→ DB slug:', dbSlug);

//   try {
//     const res = await fetch(`${API_BASE}/get_region_events.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) {
//       console.warn('fetchRegionEvents API error:', json.message);
//       return [];
//     }
//     console.log('fetchRegionEvents data:', json.data);
//     return json.data || [];
//   } catch (err) {
//     console.error("fetchRegionEvents error:", err);
//     return [];
//   }
// }



// export async function fetchRegionPublications(slug) {
//   if (!slug) return [];
//   const dbSlug = SLUG_OVERRIDES[slug] || slug;
//   try {
//     const res = await fetch(`${API_BASE}/get_region_publications.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) {
//       console.warn('fetchRegionPublications API error:', json.message);
//       return [];
//     }
//     return json.data || [];
//   } catch (err) {
//     console.error("fetchRegionPublications error:", err);
//     return [];
//   }
// }


// // Add these functions to regionApi.js

// export async function fetchRegionPressReleases(slug) {
//   if (!slug) return [];
//   const dbSlug = getDbSlug(slug);
//   try {
//     const res = await fetch(`${API_BASE}/get_region_press_releases.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) {
//       console.warn('fetchRegionPressReleases API error:', json.message);
//       return [];
//     }
//     return json.data || [];
//   } catch (err) {
//     console.error("fetchRegionPressReleases error:", err);
//     return [];
//   }
// }

// export async function fetchRegionPressCoverage(slug) {
//   if (!slug) return [];
//   const dbSlug = getDbSlug(slug);
//   try {
//     const res = await fetch(`${API_BASE}/get_region_press_coverage.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();
//     if (!json.success) {
//       console.warn('fetchRegionPressCoverage API error:', json.message);
//       return [];
//     }
//     return json.data || [];
//   } catch (err) {
//     console.error("fetchRegionPressCoverage error:", err);
//     return [];
//   }
// }




// new new code 






// regionApi.js

const API_BASE = "https://assocham.org/assocham_backend/api";

// Explicit overrides for states where the frontend slug differs from the DB slug
const SLUG_OVERRIDES = {
  // "tamil-nadu": "tamil-nadu-state-development-council",
  // "telangana": "telangana-state-development-council",
  // Add others if they don't follow the pattern
  // "andhra-pradesh": "andhra-pradesh-state-development-council",
  // "karnataka": "karnataka-state-development-council",
};

/**
 * Convert a frontend slug (e.g., "tamil-nadu") to the database slug.
 * If there's no explicit override, we append "-state-development-council"
 * unless the slug already ends with that string.
 */
function getDbSlug(frontendSlug) {
  if (!frontendSlug) return frontendSlug;
  const trimmed = frontendSlug.trim();
  const override = SLUG_OVERRIDES[trimmed];
  if (override) return override;
  // If it doesn't already end with "-state-development-council", add it.
  if (!trimmed.endsWith('-state-development-council')) {
    return `${trimmed}-state-development-council`;
  }
  return trimmed;
}

export async function getRegionBySlug(slug) {
  if (!slug) return null;
  const dbSlug = getDbSlug(slug);
  console.log('[getRegionBySlug] frontend slug:', slug, '→ DB slug:', dbSlug);

  try {
    const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();
    if (!json.success) return null;
    return json.data;
  } catch (err) {
    console.error("getRegionBySlug error:", err);
    return null;
  }
}

export async function getCouncilLeadership(slug) {
  if (!slug) return [];
  const dbSlug = getDbSlug(slug);
  try {
    const res = await fetch(`${API_BASE}/getCouncilLeadership-state.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();
    if (json.success) {
      return json.data;
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch council leadership:', error);
    return [];
  }
}

export async function fetchRegionEvents(slug) {
  if (!slug) return [];
  const dbSlug = getDbSlug(slug);
  console.log('[fetchRegionEvents] frontend slug:', slug, '→ DB slug:', dbSlug);

  try {
    const res = await fetch(`${API_BASE}/get_region_events.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();
    if (!json.success) {
      console.warn('fetchRegionEvents API error:', json.message);
      return [];
    }
    return json.data || [];
  } catch (err) {
    console.error("fetchRegionEvents error:", err);
    return [];
  }
}

export async function fetchRegionPublications(slug) {
  if (!slug) return [];
  const dbSlug = getDbSlug(slug);
  try {
    const res = await fetch(`${API_BASE}/get_region_publications.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();
    if (!json.success) {
      console.warn('fetchRegionPublications API error:', json.message);
      return [];
    }
    return json.data || [];
  } catch (err) {
    console.error("fetchRegionPublications error:", err);
    return [];
  }
}

export async function fetchRegionPressReleases(slug) {
  if (!slug) return [];
  const dbSlug = getDbSlug(slug);
  try {
    const res = await fetch(`${API_BASE}/get_region_press_releases.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();
    if (!json.success) {
      console.warn('fetchRegionPressReleases API error:', json.message);
      return [];
    }
    return json.data || [];
  } catch (err) {
    console.error("fetchRegionPressReleases error:", err);
    return [];
  }
}

export async function fetchRegionPressCoverage(slug) {
  if (!slug) return [];
  const dbSlug = getDbSlug(slug);
  try {
    const res = await fetch(`${API_BASE}/get_region_press_coverage.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();
    if (!json.success) {
      console.warn('fetchRegionPressCoverage API error:', json.message);
      return [];
    }
    return json.data || [];
  } catch (err) {
    console.error("fetchRegionPressCoverage error:", err);
    return [];
  }
}